module.exports = __webpack_public_path__ + "./assets/784072c79d0b06aa29c9a3aadc174e13.woff";